import { reportRaptorMetrics } from '@/src/common/SLRaptor';

export class ImgBottomLabelMonitor {
  /**
   * 通参
   */
  defaultTags = {
    osName: Mach.env.osName ?? '',
    osVersion: Mach.env.osVersion ?? '',
    appVersion: Mach.env.version ?? '',
    platform: Mach.env.isAndroid ? 'Android' : 'iOS',
    bundleVersion: Mach.env.bundleVersion,
  };

  /**
   * 上报异形价格腰封下发数据是否正常
   */
  reportSpuPriceLabelData = (value, params = {}) => {
    const tags = { ...this.defaultTags, ...params };
    reportRaptorMetrics({ SpuPriceLabelDataValid: value }, tags);
  };
}
